export default __webpack_public_path__ + "static/media/Back panel repair.e1260741.png";